import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { Otp } from "../../Otp";
import routes from "../../../routes";
import { StyledFormConfirm } from "./styled";
import { getSelectedStakeholder } from "../../../store/selectors/stakeholders";
import {
  getIsEmailChanged,
  getIsMobileChanged,
  getIsSignatoryPrimaryEmailChanged,
  getIsSignatoryPrimaryMobileNoChanged
} from "../../../store/selectors/appConfig";
import { VIEW_IDS } from "../../../constants";

export const FormConfirmCompanyAndSignatory = ({ otpType, title, info, changeText }) => {
  const location = useLocation();
  const selectedPartner = useSelector(getSelectedStakeholder);
  const isCompanyEmailChanged = useSelector(getIsEmailChanged);

  const isCompanyMobileChanged = useSelector(getIsMobileChanged);
  const isSignatoryPrimaryMobileChanged = useSelector(getIsSignatoryPrimaryMobileNoChanged);
  const isSignatoryPrimaryEmailChanged = useSelector(getIsSignatoryPrimaryEmailChanged);
  const isFromPreview = location?.state?.isFromPreview;

  let redirectTo = "";

  if (isCompanyMobileChanged) {
    redirectTo = routes.verifyEmailOtp;
  } else if (isCompanyEmailChanged) {
    redirectTo = routes.verifyEmailOtp;
  } else if (isSignatoryPrimaryMobileChanged || isSignatoryPrimaryEmailChanged) {
    redirectTo = routes.companyAndPartnerOTPVerification;
  } else if (selectedPartner?.viewId === VIEW_IDS.StakeholdersInfoPreview) {
    redirectTo = routes.StakeholderTermsAndConditions;
  } else if (selectedPartner?.viewId === VIEW_IDS.PartnershipSummaryInfo) {
    redirectTo = routes.stakeholdersInfo;
  } else if (isFromPreview) {
    redirectTo = routes.StakeholderTermsAndConditions;
  } else {
    redirectTo = selectedPartner?.viewId;
  }

  return (
    <div>
      <StyledFormConfirm data-testid="otp-form-confirm-wrapper">
        <Otp
          title={title}
          info={info}
          changeText={changeText}
          otpType={otpType}
          redirectRoute={redirectTo}
          selectedPartner={selectedPartner}
          classes={{
            centeredContainer: "centeredContainer",
            title: "title"
          }}
          isFromPreview={isFromPreview}
        />
      </StyledFormConfirm>
    </div>
  );
};
